module.exports = __webpack_public_path__ + "img/czdq.178a12a8.png";